export default "__VITE_ASSET__3bec4db4__"